import { FilterOptionsState } from '@mui/material';
import { AutocompleteOption as BaseAutocompleteOption } from 'redesign';
import { sanitizeString } from 'shared/utils/utils';
import { ShiftPlanningFiltersCompany } from 'hq/services/shift-planning-service.types';
import { BusinessUnitsFilterBranchOffice } from '../inputs/business-units/filter-business-units.types';
import { getDepartmentsFromSelectedBranchOffices } from '../inputs/business-units-with-company/get-business-units-with-company-options';

type AutocompleteOption = BaseAutocompleteOption & {
  branchOfficeName?: string;
};

type DepartmentFilterArgs = {
  selectedDepartments?: AutocompleteOption[] | null;
  selectedBranchOffices?: AutocompleteOption[] | null;
  branchOffices?: BusinessUnitsFilterBranchOffice[];
  companies?: ShiftPlanningFiltersCompany[];
  selectedCompanyId?: string | number;
};

export const getFilterOptions = (
  autocompleteOptions: AutocompleteOption[] | null,
  autocompleteState: FilterOptionsState<any>
) => {
  if (!autocompleteOptions?.length) {
    return [];
  }

  if (autocompleteOptions && autocompleteState.inputValue.length === 0) {
    return autocompleteOptions;
  }

  const sanitizedInputValue = sanitizeString(autocompleteState.inputValue);
  return autocompleteOptions.filter((autocompleteOption) => {
    const sanitizedAutocompleteOption = sanitizeString(autocompleteOption.label);
    return sanitizedAutocompleteOption.includes(sanitizedInputValue);
  });
};

export const filterValidDepartments = ({
  selectedDepartments,
  selectedBranchOffices,
  branchOffices,
  companies,
  selectedCompanyId,
}: DepartmentFilterArgs): AutocompleteOption[] => {
  if (!selectedBranchOffices?.length) {
    return [];
  }

  let validDepartments: AutocompleteOption[] = [];

  if (companies && selectedCompanyId) {
    const companyData = companies.find((c) => c.companyId === selectedCompanyId);
    validDepartments = companyData
      ? getDepartmentsFromSelectedBranchOffices(companyData.branchOffices, selectedBranchOffices)
      : [];
  } else if (branchOffices) {
    validDepartments = getDepartmentsFromSelectedBranchOffices(
      branchOffices,
      selectedBranchOffices
    );
  }

  const validDepartmentIds = validDepartments.map((d) => d.value);

  return (selectedDepartments || []).filter((d) => validDepartmentIds.includes(d.value));
};
